import { useContext, useEffect, useState } from "react"
import { NotificationContext } from "shared/NotificationContext"
import { NotificationType, PublicLead } from "shared/topchef.types"
import { useBackofficeApi } from 'shared/useBackofficeApi';
import Loading from "pages/shared/loading/Loading"

import { useErrorBoundary } from "react-error-boundary"
import { useTranslation } from "react-i18next";


const BackofficeDashboard = () => {
  const { t } = useTranslation();
  const [leadsLoaded, setLeadsLoaded] = useState(false);
  const [allLeads, setAllLeads] = useState<PublicLead[]>([]);
  const [signedLeadsCount, setSignedLeadsCount] = useState<number>(0);
  const [leadsToValidateCount, setLeadsToValidateCount] = useState<number>(0);
  const [billsToValidateCount, setBillsToValidateCount] = useState<number>(0);
  const [activedPlacesCount, setactivedPlacesCount] = useState<number>(0);

  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;
  const { showBoundary } = useErrorBoundary();
  const backofficeApi = useBackofficeApi();

  const [availableLeadsCount, setAvailableLeadsCount] = useState<number>(0);

useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps
  setLeadsLoaded(false);
}, [backofficeApi.country]);

useEffect(() => {
  async function loadDashboardData() {
    try {
      const [
        allLeadsRes,
        leadsToValidateRes,
        billsToValidateRes,
        availableLeadsRes,
        signedLeadsRes,
        activedPlacesRes
      ] = await Promise.all([
        backofficeApi.loadAllLeads(),
        backofficeApi.loadLeadsToValidate(),
        backofficeApi.loadBillsToValidate(),
        backofficeApi.loadAvailableLeads(),
        backofficeApi.loadSignedLeads(),
        backofficeApi.loadActivedPlaces()
      ]);

      setAllLeads(allLeadsRes);
      setLeadsToValidateCount(leadsToValidateRes.length);
      setBillsToValidateCount(billsToValidateRes.length);
      setAvailableLeadsCount(availableLeadsRes.length);
      setSignedLeadsCount(signedLeadsRes.length);
      setLeadsLoaded(true);
      setactivedPlacesCount(activedPlacesRes.length);

    } catch (error: any) {
      const newError = new Error(t('apiErrors.loadBackofficeDashboard', { details: error.message }) as string);
      triggerNotification({ type: NotificationType.error, message: newError.message });
      showBoundary(newError);
    }
  }

  if (!leadsLoaded) {
    loadDashboardData();
  }
}, [leadsLoaded, backofficeApi, triggerNotification, showBoundary]); // eslint-disable-line react-hooks/exhaustive-deps


  if (!leadsLoaded) {
    return <Loading />;
  }

  return (
    <>
      <div className="container page-bo-admin p-5 row g-4">
        <h1>{t('dashboard.backofficeTitle')}</h1>
        <div className="col-md-2 w-20">
            <div id="bo_briefs_total" className="card p-3 text-center">
            <p className="fw-bold mb-2">{t('dashboard.totalBriefs')}</p>
                <h3 id="bo_briefs_total_count" className="mb-0">{allLeads.length}</h3>
            <a className="bo-voir-plus" href="/backoffice/leads/all">{t('common.seeMore')}</a>
            </div>
        </div>
        <div className="col-md-2 w-20">
            <div id="bo_available_briefs" className="card p-3 text-center">
            <p className="fw-bold mb-2">{t('dashboard.availableBriefs')}</p>
                <h3 id="bo_available_briefs_count" className="mb-0">{availableLeadsCount}</h3>
            </div>
        </div>
        <div className="col-md-2 w-20">
            <div id="bo_leads_to_validate" className="card p-3 text-center">
            <p className="fw-bold mb-2">{t('dashboard.briefsToValidate')}</p>
                <h3 id="bo_leads_to_validate_count" className="mb-0">{leadsToValidateCount}</h3>
            <a className="bo-voir-plus" href="/backoffice/leads/to-validate">{t('common.seeMore')}</a>
            </div>
        </div>
        <div className="col-md-2 w-20">
            <div id="bo_invoices_to_validate" className="card p-3 text-center">
            <p className="fw-bold mb-2">{t('dashboard.billsToValidate')}</p>
                <h3 id="bo_invoices_to_validate_count" className="mb-0">{billsToValidateCount}</h3>
            <a className="bo-voir-plus" href="/backoffice/leads/bills-to-validate">{t('common.seeMore')}</a>
            </div>
        </div>
        <div className="col-md-2 w-20">
            <div id="bo_signed_briefs" className="card p-3 text-center">
            <p className="fw-bold mb-2">{t('dashboard.signedBriefs')}</p>
                <h3 id="bo_signed_briefs_count" className="mb-0">{signedLeadsCount}</h3>
            </div>
        </div>
        <div className="col-md-2 w-20">
            <div id="bo_actived_places" className="card p-3 text-center">
            <p className="fw-bold mb-2">{t('dashboard.activatedAccounts')}</p>
                <h3 id="bo_actived_places_count" className="mb-0">{activedPlacesCount}</h3>
            <a className="bo-voir-plus" href="/backoffice/actived-places">{t('common.seeMore')}</a>
            </div>
        </div>

      </div>
    </>
  );
};


export default BackofficeDashboard;
